module.exports = __webpack_public_path__ + "static/img/jlawp.69f7f0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/jlawp.png
// module id = STYh
// module chunks = 1